export default {
  label: {
    series: {
      engagedContacts: 'Engaged Contacts',
      nonEngagedContacts: 'Non-Engaged Contacts',
    },
  },
};
